import React from 'react'
import classes from './ButtonGroup.module.scss'

export type ButtonGroupProps = {
  children: Array<any>
}

const ButtonGroup = ({ children }: ButtonGroupProps) => {
  return <div className={classes.root}>{children}</div>
}

export default ButtonGroup
